import React from "react";

const fmtDT = (d) => {
  try {
    return new Date(d).toLocaleString("pt-BR", {
      day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit",
    });
  } catch { return "—"; }
};

const ST_AVISO = { Novo: "#FEF9C3", Visto: "#DBEAFE", Resolvido: "#DCFCE7" };
const CL_AVISO = { Novo: "#713F12", Visto: "#1E40AF", Resolvido: "#166534" };

export function HistoricoAviso({ historico = [], labelCondomino = "Condômino" }) {
  if (!historico?.length) return null;
  return (
    <div style={{ marginBottom: 10, display: "flex", flexDirection: "column", gap: 6 }}>
      {historico.map((m, i) => (
        <div key={m.id || i} style={{
          padding: "8px 10px", borderRadius: 8, fontSize: 13,
          background: m.autor === "Portaria" ? "#EFF6FF" : "#F8FAFC",
          border:"1px solid var(--border-color)",
        }}>
          <div style={{ fontSize: 10, fontWeight: 700, color:"var(--gray-500)", marginBottom: 4 }}>
            {m.autor === "Portaria" ? "Portaria" : labelCondomino} · {fmtDT(m.dtCriacao)}
          </div>
          <div style={{ whiteSpace: "pre-wrap", color: "#334155" }}>{m.mensagem}</div>
        </div>
      ))}
    </div>
  );
}

function ultimaMensagem(aviso) {
  const hist = aviso.historico?.length
    ? aviso.historico
    : [{ mensagem: aviso.mensagem }];
  const last = hist[hist.length - 1];
  const txt = (last?.mensagem || "").trim();
  return txt.length > 80 ? `${txt.slice(0, 80)}…` : txt;
}

export function AbasAvisos({ aba, onAba, qtdAbertos, qtdResolvidos }) {
  const tabStyle = (id) => ({
    border: "none",
    background: aba === id ? "#EFF6FF" : "transparent",
    color: aba === id ? "#1B3A6B" : "#64748B",
    fontWeight: aba === id ? 700 : 500,
    padding: "10px 16px",
    fontSize: 13,
    cursor: "pointer",
    borderBottom: aba === id ? "3px solid #1B3A6B" : "3px solid transparent",
    display: "flex",
    alignItems: "center",
    gap: 6,
  });
  return (
    <div style={{ display: "flex", borderBottom:"1px solid var(--border-color)", marginBottom: 14 }}>
      <button type="button" style={tabStyle("abertos")} onClick={() => onAba("abertos")}>
        Em aberto
        {qtdAbertos > 0 && (
          <span style={{
            background: "#EF4444", color: "#fff", fontSize: 10,
            borderRadius: 10, padding: "1px 6px", fontWeight: 700,
          }}>{qtdAbertos}</span>
        )}
      </button>
      <button type="button" style={tabStyle("resolvidos")} onClick={() => onAba("resolvidos")}>
        Resolvidos
        {qtdResolvidos > 0 && (
          <span style={{
            background: "#E2E8F0", color:"var(--gray-600)", fontSize: 10,
            borderRadius: 10, padding: "1px 6px", fontWeight: 700,
          }}>{qtdResolvidos}</span>
        )}
      </button>
    </div>
  );
}

export function AvisoCardColapsavel({
  aviso,
  aberto,
  onToggle,
  labelUnidade,
  children,
  cardClass = "card",
}) {
  const a = aviso;
  const resolvido = a.status === "Resolvido";
  return (
    <div
      className={cardClass}
      style={{
        marginBottom: 8, overflow: "hidden",
        opacity: resolvido ? 0.92 : 1,
        border: resolvido ? "1px solid #E2E8F0" : undefined,
      }}
    >
      <button
        type="button"
        onClick={onToggle}
        style={{
          width: "100%", border: "none", background: resolvido ? "#F8FAFC" : "#fff",
          padding: "12px 14px", textAlign: "left", cursor: "pointer",
          display: "flex", alignItems: "flex-start", gap: 10,
        }}
      >
        <i
          className={`bi bi-chevron-${aberto ? "down" : "right"}`}
          style={{ color:"var(--gray-400)", marginTop: 2, flexShrink: 0 }}
        />
        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{ display: "flex", flexWrap: "wrap", gap: 6, alignItems: "center", marginBottom: 4 }}>
            <span style={{
              fontSize: 10, fontWeight: 700, padding: "2px 6px", borderRadius: 4,
              background: ST_AVISO[a.status] || "#F1F5F9",
              color: CL_AVISO[a.status] || "#475569",
            }}>{a.status}</span>
            {a.urgencia === "Urgente" && (
              <span style={{
                fontSize: 10, fontWeight: 700, padding: "2px 6px", borderRadius: 4,
                background:"var(--bg-danger-soft)", color: "#991B1B",
              }}>Urgente</span>
            )}
            <span style={{ fontSize: 11, color:"var(--gray-500)" }}>{a.tpAviso}</span>
            <span style={{ fontSize: 11, color:"var(--gray-400)", marginLeft: "auto" }}>{fmtDT(a.dtCriacao)}</span>
          </div>
          <div style={{ fontWeight: 600, fontSize: 13, color:"var(--text-primary)" }}>
            {labelUnidade}
            {a.nmCondomino ? ` · ${a.nmCondomino}` : ""}
          </div>
          {!aberto && (
            <div style={{ fontSize: 12, color:"var(--gray-400)", marginTop: 4, whiteSpace: "nowrap",
              overflow: "hidden", textOverflow: "ellipsis" }}>
              {ultimaMensagem(a)}
            </div>
          )}
        </div>
      </button>
      {aberto && (
        <div style={{ padding: "0 14px 14px 28px", borderTop: "1px solid #F1F5F9" }}>
          {children}
        </div>
      )}
    </div>
  );
}

export function filtrarAvisos(avisos, { aba, idUnidade } = {}) {
  let lista = avisos || [];
  if (aba === "abertos") lista = lista.filter((a) => a.status !== "Resolvido");
  if (aba === "resolvidos") lista = lista.filter((a) => a.status === "Resolvido");
  if (idUnidade) lista = lista.filter((a) => String(a.idUnidade) === String(idUnidade));
  return lista;
}

export function contarAvisos(avisos, idUnidade) {
  let base = avisos || [];
  if (idUnidade) base = base.filter((a) => String(a.idUnidade) === String(idUnidade));
  return {
    abertos: base.filter((a) => a.status !== "Resolvido").length,
    resolvidos: base.filter((a) => a.status === "Resolvido").length,
  };
}
